import { useAppDispatch, useAppSelector } from '../../../../../../base/hooks';
import { __t } from '../../../../../../base/utils/t';
import { ReactComponent as ConfirmPhoneIcon } from '../../../../../assets/img/confirm-phone-icon.svg';
import { workerAppActions } from '../../../../../redux/slices/workerAppSlice';
import { signUpActions } from '../../../redux/slices/signUpSlice';
import { Confirmation as ConfirmationComponent } from '../../../../../components/Confirmation';

import './styles.scss';

export const Confirmation = () => {
    const dispatch = useAppDispatch();
    const {
        fields: { phone, smsCode },
        errors,
    } = useAppSelector((state) => state.workerAppSignUp);

    const verificationCodeChangeHandler = (value: unknown) => {
        dispatch(signUpActions.setField({ id: 'smsCode', value }));
    };

    const submitResendCode = (recaptchaToken: string | null, callback: () => void) => {
        dispatch(workerAppActions.sendConfirmationCode(phone, recaptchaToken, callback));
    };

    const submitChangeConfirmationValue = (newValue: string, recaptchaToken: string | null, callback: () => void) => {
        dispatch(signUpActions.submitChangeConfirmationValue(newValue, recaptchaToken, callback));
    };

    return (
        <div className='worker-signup-confirmation'>
            <ConfirmPhoneIcon className='worker-signup-confirmation__icon' />
            <h2 className='worker-signup-confirmation__title'>{__t('Подтвердите номер телефона')}</h2>
            <ConfirmationComponent
                codeValue={smsCode || ''}
                confirmationMethod='phone'
                text={
                    <>
                        {__t('Введите код, который мы отправили на')}
                        <br />
                        <strong>{phone}</strong>
                    </>
                }
                codeErrors={errors?.smsCode}
                changeConfirmationValueErrors={errors?.phone}
                updateModalText={__t('Мы отправим код для подтверждения')}
                verificationCodeChangeHandler={verificationCodeChangeHandler}
                submitResendCode={submitResendCode}
                submitChangeConfirmationValue={submitChangeConfirmationValue}
            />
        </div>
    );
};
